import { useContext } from "react";
import { UserContext } from "../../contexts/UserContext";
import { TechsContexts } from "../../contexts/TechsContext";

import { Tech } from "../Tech";
import { EventButton } from "../Button/index";

import {
  StyledTechList,
  StyledHeader,
  StyledTechListContainer,
} from "./styles";

export const TechList = () => {
  const { userTechsList, loading } = useContext(UserContext);
  const { setShowAddModal } = useContext(TechsContexts);

  return (
    <>
      {loading ? (
        <div>Carregando</div>
      ) : (
        <StyledTechListContainer>
          <StyledHeader>
            <h2>Tecnologias</h2>
            <EventButton
              type="button"
              buttonSize={"medium"}
              buttonStyle={"medium-style"}
              onClick={() => setShowAddModal(true)}
              link=""
            >
              Adicionar
            </EventButton>
          </StyledHeader>
          <StyledTechList>
            {userTechsList.map((data) => {
              const { id, title, status } = data;
              return <Tech key={id} id={id} title={title} status={status} />;
            })}
          </StyledTechList>
        </StyledTechListContainer>
      )}
    </>
  );
};
